// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    about_item: 'Acerca de {0}',
    activity_plural: '1#{0} actividad#{0} actividades',
    add: 'Agregar',
    AddMoreSpace: 'Actualiza ahora',
    all_projects_label: 'Todos los proyectos',
    approve_label: 'Aprobar',
    approved: 'Aprobado',
    approvers: 'Aprobador',
    archive_action_text: 'Archivar',
    archive_date_label: 'Fecha de archivo',
    archived_by_label: 'Archivado por',
    Attach: 'Adjuntar archivo',
    attach_file_image: 'Adjuntar archivo o imagen',
    automation_purchase_notes: 'Por favor, contacta a <a href=\'mailto:billing@birdviewpsa.com\'>billing@birdviewpsa.com</a> si deseas utilizar un método de pago diferente a una tarjeta de débito.',
    automation_trial_description_end: 'y descubre la automatización de Birdview en acción!',
    automation_trial_description_middle: 'Prueba gratuita de 30 días',
    automation_trial_description_start: 'Comienza con nuestra ',
    automation_trial_expired: 'Tu prueba ha expirado.',
    automation_trial_expired_notes: 'Por favor, comunícate con nuestro <a href=\'mailto:support@birdviewpsa.com\'>soporte@birdviewpsa.com</a> para obtener más ayuda.',
    btn_reload: 'Recargar',
    buy_subscription: 'Comprar suscripción',
    Cancel: 'Cancelar',
    change: 'Cambiar',
    checkbox_list_text: 'Selección múltiple',
    Close: 'Cerrar',
    completeActivityConfirm: 'Has especificado que esta actividad está 100% completa. ¿Quieres completarla? Pulsa \'OK\' para cambiar el estatus, o \'Cancelar\' en caso contrario.',
    completeActivityTitle: '¿Quieres completar esta actividad?',
    completeProjectConfirm: 'Has especificado que este proyecto está 100% completo. ¿Quieres completarlo? Pulsa \'OK\' para cambiar el estatus.',
    completeProjectTitle: '¿Quieres completar este proyecto?',
    confirmCompleteActivityParents: 'Completar esta actividad dejará sin actividades incompletas en este proyecto (actividad principal). ¿Te gustaría completar también el proyecto o la actividad principal, según corresponda?',
    confirmCompleteActivityParentsTitle: '¿Establecer el estatus de {0} como completado?',
    contact_us: 'Contáctanos',
    continue: 'Continuar',
    copied_label: 'Copiado',
    copy_link_feedback: 'Enlace copiado.',
    copying_label: 'Copiando',
    copyLink: 'Copiar enlace',
    custom_field_label: 'Campo personalizado',
    custom_form_label: 'Formulario personalizado',
    date_text: 'Fecha',
    DayAbbreviation: 'd',
    DayPluralFormat: '1#día#días',
    DayPluralFormatTemplate: '1#{0} día#{0} días',
    Delete: 'Eliminar',
    delete_confirmation: 'Esta acción no se puede deshacer.',
    delete_permanently_text: 'Eliminar permanentemente',
    description_information: 'para {0}',
    disabled: 'Deshabilitado',
    disabledUserText: '(deshabilitado)',
    Download: 'Descargar',
    dropdown_text: 'Desplegable',
    Duplicate: 'Duplicar',
    Edit: 'Editar',
    ElapsedTime_Ago: 'hace {0}',
    enabled: 'Habilitado',
    Entity_Category: 'Categoría',
    Entity_Customer: 'Cliente',
    Entity_Invoice: 'Factura',
    Entity_Issue: 'Incidencia',
    Entity_JobRole: 'Rol de trabajo',
    Entity_OAuthAccountClient: 'Cliente OAuth',
    Entity_Portfolio: 'Portafolio',
    Entity_Priority: 'Prioridad',
    Entity_Project: 'Proyecto',
    Entity_ProjectStatus: 'Estatus',
    Entity_Request: 'Solicitud',
    Entity_Task: 'Tarea',
    Entity_TaskStatus: 'Estatus',
    Entity_User: 'Usuario',
    Error_CantFindObjectTemplate: 'No se pudo completar la operación por la(s) siguiente(s) razón(es): elemento (tipo: {entityName}, ID: {objectKey}) no encontrado en la base de datos.  Esto puede deberse a la eliminación del elemento o a la falta de permisos para verlo. Consulta con tu administrador de {brandName} para conocer las posibles causas.',
    error_notFullyCompleted: 'Un objeto o usuario involucrado ha sido eliminado o los permisos de acceso han sido revocados por otro usuario.',
    ErrorFileSizeLimit: 'No se pudo completar la carga del archivo {0}, porque no puedes cargar un archivo mayor a ∼ {1} GB',
    ErrorUploadExceededText: 'No se pudo completar la carga del archivo {0}, porque tu cuenta se ha quedado sin espacio.',
    ErrorUploadText: 'La carga del archivo {0} encontró un error desconocido y no pudo completarse. Por favor, repite el proceso de carga.',
    ErrorUploadTitle: 'Error al cargar el archivo.',
    ErrorVirusText: 'El archivo que intentas adjuntar puede contener un virus. Por favor, elimina el archivo y realiza un escaneo de seguridad en tu equipo.',
    ErrorVirusTitle: 'Archivo con virus',
    exported: 'Exportado',
    exporting: 'Exportando',
    failed: 'Fallido',
    help: 'Ayuda',
    HourAbbreviation: 'h',
    HourPluralFormat: '1#hora#horas',
    HourPluralFormatTemplate: '1#{0} hora#{0} horas',
    HyperLinkTooltip: 'CTRL+Click para seguir el enlace',
    items_selected_plural: '1#{0} elemento seleccionado#{0} elementos seleccionados',
    madeBy: 'Desarrollado por',
    MinuteAbbreviation: 'm',
    MinutePluralFormat: '1#{0} min#{0} min',
    more_counter_text: 'y {0} más',
    next: 'Siguiente',
    no_items_selected: 'Ningún elemento seleccionado',
    None_Text: 'Ninguno',
    Not_set: 'No establecido',
    Ok: 'OK',
    one_after_another_label: 'Aprobación secuencial',
    one_after_another_tooltip: 'Los aprobadores deben aprobar en un orden establecido, uno tras otro',
    open_details_new_tab: 'Abrir detalles en una nueva pestaña',
    open_in_new_tab: 'Abrir en una nueva pestaña',
    OpeningWindow: 'Abriendo...',
    OpenOriginal: 'Abrir original',
    OperationError_Title: 'No se pudo completar la operación',
    paragraph_text: 'Texto de párrafo',
    parentActivity: 'actividad principal',
    PerDay: 'por día',
    PerWeek: 'por semana',
    project_custom_fields_label: 'Campos personalizados del proyecto',
    project_plural: '1#{0} proyecto#{0} proyectos',
    reject_label: 'Rechazar',
    rejected: 'Rechazado',
    Remove: 'Quitar',
    request_has_been_sent_successfully: 'La solicitud se ha enviado correctamente. El equipo de éxito se pondrá en contacto contigo.',
    Request_Trial: 'Pruébalo ahora',
    Reset: 'Restablecer',
    Save: 'Guardar',
    saved: 'Guardado',
    saving: 'Guardando',
    Search: 'Buscar',
    select_placeholder: 'Seleccionar...',
    selection_mode_text: 'Modo de selección',
    sending: 'Enviando',
    setCompleted: 'Marcar como Completado',
    show_less_label: 'Mostrar menos',
    show_more_label: 'Mostrar más',
    space_exceeded_description: 'No hay suficiente espacio de almacenamiento disponible para guardar archivos.',
    space_exceeded_title: 'El almacenamiento está lleno',
    status: 'Estatus',
    submit: 'Enviar',
    subscribe_trouble_description: 'Por favor, contacte a <a href=\'mailto:success@birdviewpsa.com\'>success@birdviewpsa.com</a> para aclarar el estatus de su suscripción.',
    summary: 'Resumen',
    time_input_placeholder: 'Introduzca el tiempo, por ejemplo: 2h 30m',
    timer_text: '1#{0} segundo#{0} segundos',
    title_notFullyCompleted: 'La operación no pudo completarse parcial o totalmente',
    title_reload: 'Por favor, recargue la página',
    total: 'Total',
    turn_off: 'Apagar',
    type: 'Tipo',
    Type_for_search: 'Escriba para buscar',
    Type_for_search_or_add: 'Escriba para buscar o agregar',
    Type_for_search_or_create: 'Escriba para buscar o crear',
    unarchive_action_text: 'Desarchivar',
    undo_label: 'Deshacer',
    undoing: 'Deshaciendo',
    undone: 'Deshecho',
    upload: 'Subir',
    waitingForApproval: 'Esperando aprobación',
    WebPushNotificationPanelLink: 'habilitar notificaciones de escritorio.',
    WebPushNotificationPanelText: '{brandName} necesita su permiso para ',
    you_user_text: '(tú)',
};
